import { Info } from "lucide-react";
import type { ReactNode } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * The small yellow info affordance used across the HCBB results — beside a
 * price figure in the highlight card, and beside each row's estimated cost.
 *
 * Always a real `<button>`: a tooltip needs a focusable trigger, or the hint
 * is mouse-only. With `onClick` it also opens something (the disclaimer
 * panel), and the label then has to name what opens rather than describing
 * the icon.
 */
export const HcbbInfoHint = ({
  label,
  children,
  onClick,
}: {
  /** Accessible name — what the hint is about, or what it opens. */
  label: string;
  /** Tooltip body. */
  children: ReactNode;
  onClick?: () => void;
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        aria-label={label}
        onClick={onClick}
        className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info height={15} className="text-yellow-500" aria-hidden="true" />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-64">
      <p className="text-xs text-gray-600">{children}</p>
    </TooltipContent>
  </Tooltip>
);
